import type { Action } from '../action'
import { ResourceType } from '../resource-type'

/**
 * Nav chrome gated by action rather than by resource existence. Statically
 * known, so the client checks the whole group in one batch `simulate` at app
 * load
 */
export const NAVIGATION_ACTIONS = {
  'admin:portal:access': {
    description: 'Open the Tenant Admin Portal',
    resourceTypes: [ResourceType.Tenant],
  },
} as const satisfies Record<string, Action.Definition>
